import React, { Component, Fragment } from 'react';
import Home from './components/Home/Home';
import Mo from './components/Mo/Mo';
import Sample from './components/Sample/Sample';
import Feature from './components/Features/Feature';
import Pricing from './components/Pricing/Pricing';
import Powered from './components/Powered';
import Footer from './components/Footer/Footer';
import ScrollToTop from 'react-scroll-up';
import '../node_modules/react-owl-carousel2/src/owl.carousel.css';
import '../node_modules/react-owl-carousel2/src/owl.theme.default.css';

class HomeData extends Component {
  render() {
    return (
        <Fragment>
          <Home />
          <Mo />
          <Sample />
          <Feature />
          <Pricing />
          <Powered />
          <Footer />
          <ScrollToTop showUnder={160}>
            <span><i className="fas fa-chevron-circle-up fa-2x back-to-top"></i></span>
          </ScrollToTop>
        </Fragment>
    );
  }
}

export default HomeData;



// WEBPACK FOOTER //
// ./src/HomeData.js